import {Injectable} from "@angular/core";
import {ResponseGetAllPageAccessibleModel} from "../../model/app-page.model";

@Injectable()
export class AccessDataService {
  public AllPageAccessible: ResponseGetAllPageAccessibleModel = new ResponseGetAllPageAccessibleModel();

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/pagebuilder/services/data/access-data.service.ts